import React from "react";
import { Row, Col, Button } from "reactstrap";
import "./index.css";

const PrizeRightSide = ({ title, handleClick, isLogo, step, nextButton }) => {
  const titleLines = title.split("\n");
  return (
    <div className="align-items-center right-side">
      <div>
        <Row>
          <Col className="m-0 p-0">
            {titleLines.map((line, index) => (
              <Row>
                <span key={index} className="title-col-2">
                  {line}
                </span>
              </Row>
            ))}
          </Col>
        </Row>
        <Row>
          <Col lg={{ size: 4, offset: 2 }}>
            <div className="d-flex flex-row justify-content-center">
              <div
                className={`rounded-circle base-circle ${
                  step === 1 ? "active-circle" : "secondary-circle"
                }`}
              >
                <span>1</span>
              </div>
              <div className="ms-2">
                <span className="title-steps">Adjunto tu logo</span>
                <br />
                <span className="subtitle-steps">
                  Configura el logo de tu perfil
                </span>
              </div>
            </div>
          </Col>
          <Col lg={{ size: 4 }}>
            <div className="d-flex flex-row">
              <div
                className={`rounded-circle base-circle ${
                  step === 2 ? "active-circle" : "secondary-circle"
                }`}
              >
                <span>2</span>
              </div>
              <div className="ms-2">
                <span className="title-steps">Selecciona tus Premios</span>
                <br />
                <span className="subtitle-steps">
                  Configura tus propios premios
                </span>
              </div>
            </div>
          </Col>
        </Row>
        {nextButton && (
          <Row className="mt-5 justify-content-center align-items-center">
            <Col>
              <div className="text-center">
                <Button
                  onClick={handleClick}
                  className={`laststep-button py-2 px-5 ${
                    !!isLogo ? "laststep-button-active" : ""
                  }`}
                  disabled={!!!isLogo}
                >
                  Último Paso
                  <i className="fa-solid fa-arrow-right text-white ms-2"></i>
                </Button>
              </div>
            </Col>
          </Row>
        )}
      </div>
    </div>
  );
};

export default PrizeRightSide;
